import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, confirmed, min, min_value, max_value, numeric, ext, regex } from 'vee-validate/dist/rules'
import { TypeformReferenceRegExp } from '@/api/model/typeform/typeform-form'

// @ts-ignore
import en from 'vee-validate/dist/locale/en.json'

// @ts-ignore
import nl from 'vee-validate/dist/locale/nl.json'

// Available locales
localize({
    nl,
    en,
})

// Set initial locale
localize(process.env.VUE_APP_I18N_LOCALE ?? 'en')

extend('required', required)
extend('email', email)
extend('confirmed', confirmed)
extend('min', min)
extend('min_value', min_value)
extend('max_value', max_value)
extend('numeric', numeric)
extend('ext', ext)
extend('regex', regex)

extend('uuidv4', {
    validate: (value: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value),
    message: '{_field_} is geen geldige identifier',
})

extend('password', {
    validate: (value: string) => {
        return /[A-Z]/g.test(value)
            && /[@$!%*#?&]/g.test(value)
    },
    message: 'Zorg ervoor dat er een hoofdletter en/of speciaal karakter voorkomt',
})

extend('zipcode', {
    validate: (value: string) => /[0-9]{4}\s?[a-zA-Z]{2}/g.test(value),
    message: '{_field_} moet een geldige postcode zijn',
})

extend('typeform_references', {
    validate: (value: string, args) => {
        const options = 'options' in args ? args.options : []

        const references = value.split(TypeformReferenceRegExp)
        while (references.length) {
            const reference = references.shift()
            if (!reference.match(TypeformReferenceRegExp)) {
                continue
            }

            if (!options.find(option => option.value === reference)) {
                return `{_field_} bevat een ongeldige referentie: ${reference}`
            }
        }

        return true
    },
    params: ['options'],
})

extend('url', {
    validate: (value: string, args) => {
        try {
            const url = new URL(value as string)
        } catch {
            return false
        }

        return true
    },
    message: '{_field_} moet een geldige url zijn',
})

Vue.component('validation-observer', ValidationObserver)
Vue.component('validation-provider', ValidationProvider)
